import moment from 'moment';


const isAdult = (date) => {
    const dob = moment(date);
    const start = moment().subtract(window.MINIMUM_AGE, 'years');
    return dob.isBefore(start);
  }


export const countAdults = (persons) => {
    let count = 0;
    persons.forEach(item => isAdult(item.dob) ? count++ : null)
    return count
}


export const countLeaseHolders = (persons) => {
    let count = 0;
    persons.forEach(item => item.status === 'leaseholder' ? count++ : null)
    return count
}


export const calculateTotalFee = (property, occupants, IsAdminFeePaid) => {
    const { additional_applicant_fee, application_admin_fee, application_fee } = property
    if(additional_applicant_fee === 0 && application_admin_fee === 0 && application_fee === 0 ) return 0

    //person count should exclude one person to calculate addition fee per additional leaseholder
    const adultsCount = countAdults(occupants) - 1;
    const totalFee = application_fee + (additional_applicant_fee * adultsCount) + (IsAdminFeePaid ? application_admin_fee : 0)

    return totalFee;
}
